import {Tag} from './Tag';

export enum AlertManagerState {
    ALL = "ALL", YES = "YES", NO = "NO"
}

export class Template {
    id: number;
    name: string;
    instructions: string;
    template_text: string;
    owner_id: string;
    created_by: string;
    is_alert_manager: boolean;
    is_debug: boolean;
    tags: Tag[];

    constructor(id: number, name: string, instructions: string, template_text: string, owner_id: string, is_alert_manager?: boolean, is_debug?: boolean, tags?: Tag[]) {
        this.id = id;
        this.name = name;
        this.instructions = instructions;
        this.template_text = template_text;
        this.owner_id = owner_id;
        this.is_alert_manager = is_alert_manager || false;
        this.is_debug = is_debug || false;
        this.tags = tags || [];
    }
}
